import React from 'react';
import { Observer } from 'mobx-react';


function getSvg(type) {
  switch (type) {
    case 'facebook':
      return (
        <svg className={`icon icon-facebook`} viewBox="0 0 6 13" width="100%" height="100%">
          <path d="M5.73 6.47H3.96v6.49H1.28V6.47H0V4.18h1.28V2.71c0-1.06.5-2.71 2.7-2.71l1.99.01v2.21H4.53c-.24 0-.57.12-.57.62v1.35h2.01z" />
        </svg>
      );
    case 'twitter':
      return (
        <svg className="icon icon-twitter" viewBox="0 0 12 10" width="100%" height="100%">
          <path d="M11.57 1.11c-.43.19-.89.32-1.37.38.49-.3.87-.76 1.05-1.32-.46.28-.97.47-1.51.58A2.37 2.37 0 0 0 5.7 2.91 6.67 6.67 0 0 1 .81.43a2.36 2.36 0 0 0 .73 3.17 2.45 2.45 0 0 1-1.08-.29v.03c0 1.15.82 2.1 1.91 2.32a2.18 2.18 0 0 1-1.07.04c.3.95 1.17 1.63 2.21 1.65A4.72 4.72 0 0 1 0 8.33a6.7 6.7 0 0 0 10.39-5.68l-.01-.31c.47-.33.87-.75 1.19-1.23z" />
        </svg>
      );
    case 'google':
      return (
        <svg className="icon icon-google-plus" viewBox="0 0 10 10" width="100%" height="100%">
          <path d="M1 5.1a4.07 4.07 0 0 1 3.88-4.09 4.1 4.1 0 0 1 2.94 1.01c-.33.37-.67.73-1.03 1.07-.72-.43-1.59-.77-2.42-.47a2.57 2.57 0 0 0-1.67 3.3 2.57 2.57 0 0 0 3.41 1.56 2.26 2.26 0 0 0 1.33-1.55c-.78-.01-1.57 0-2.35-.02v-1.4L9 4.52a4.61 4.61 0 0 1-.82 3.27C7.16 9.1 5.29 9.48 3.76 8.97A4.1 4.1 0 0 1 1 5.1z" />
        </svg>
      );
    case 'vkontakte':
      return (
        <svg className="icon icon-vkontakte" viewBox="0 0 14 9" width="100%" height="100%">
          <path d="M6.38 8.41h.78s.23-.03.35-.16c.11-.12.11-.34.11-.34s-.01-1.05.47-1.2c.48-.15 1.09 1.01 1.74 1.46.5.33.87.26.87.26l1.74-.02s.91-.06.48-.78c-.03-.05-.25-.53-1.29-1.49-1.1-1.02-.95-.85.37-2.61.8-1.06 1.12-1.71 1.02-1.99-.1-.27-.69-.2-.69-.2l-1.96.01s-.14-.02-.25.05a.47.47 0 0 0-.17.21s-.31.82-.73 1.53C8.35 4.62 8 4.7 7.86 4.6c-.33-.21-.25-.86-.25-1.32 0-1.43.22-2.03-.43-2.19A3.6 3.6 0 0 0 6.27 1c-.7-.01-1.29 0-1.63.17-.22.11-.39.35-.29.36.13.02.43.08.58.3.2.27.19.88.19.88s.12 1.69-.26 1.9c-.27.15-.63-.15-1.41-1.49-.4-.69-.7-1.45-.7-1.45s-.06-.14-.16-.22c-.13-.09-.3-.12-.3-.12l-1.87.01s-.27.01-.38.13c-.09.11 0 .33 0 .33s1.45 3.41 3.11 5.13c1.51 1.58 3.23 1.48 3.23 1.48z" />
        </svg>
      );
    case 'instagram':
      return (
        <svg
          className="social-icon social-icon_instagram"
          viewBox="0 0 510 512"
          width="100%"
          style={{ height: '12px', fill: '#5d6687' }}
          height="100%"
        >
          <path d="M307.814 261.565c0-27.704-22.536-50.249-50.249-50.249-27.703 0-50.248 22.545-50.248 50.249 0 27.708 22.545 50.249 50.248 50.249 27.713 0 50.249-22.541 50.249-50.25zm70.8 0c0 66.749-54.304 121.045-121.049 121.045-66.744 0-121.045-54.296-121.045-121.045 0-18.381 4.138-35.802 11.498-51.425H0v174.424C0 454.833 57.167 512 127.436 512H382.48c70.264 0 127.432-57.167 127.432-127.436V210.14H367.117a120.339 120.339 0 0 1 11.498 51.425zM362.02 77.446c0-7.791 6.365-14.156 14.161-14.156h43.746c7.791 0 14.165 6.365 14.165 14.156v43.75c0 7.792-6.374 14.161-14.165 14.161H376.18c-7.796 0-14.16-6.369-14.16-14.16v-43.75zM257.565 140.52c26.095 0 50.262 8.324 70.053 22.42h182.294v-35.504C509.912 57.167 452.744 0 382.48 0H127.436C57.167 0 0 57.167 0 127.436v35.504h187.521c19.787-14.096 43.954-22.42 70.044-22.42z" />
        </svg>
      );
    default:
      return;
  }
}

function Social({ social, isEdit }) {

  return (
    <li>
      <div className="account-head__social">
        <a
          className="account-head__link"
          href={social.url}
          title={social.type}
          target="_blank"
          rel="noopener noreferrer"
        >
          {getSvg(social.type)}
        </a>

        <Observer>
          {() => {
            return (
              <input
                disabled={!isEdit}
                className="social-edit"
                type="text"
                value={social.url}
                onChange={({ currentTarget }) => (social.url = currentTarget.value)}
                style={{ width: '200px', display: !isEdit ? 'none' : 'block' }}
              />
            );
          }}
        </Observer>
      </div>
    </li>
  );
}

export function AccountModalSocials({socials, isEdit}) {
    if (!socials) {
        return null;
    }

    return (
        <ul className="account-head__socials">
            {
            socials.map((social, idx) => (
                <Social key={idx} social={social} isEdit={isEdit}/>
            ))
            }
        </ul>
    );
}
